import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaInvestigaciones from "../Modals/crear/CreaAutoevaluacion/CreaInvestigaciones";
import Cookies from "universal-cookie";

function Titulo10SeccionA(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    obtenerLista();
  }, [props.idSolicitud]);

  const obtenerLista = async () => {
    try {
      const response = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerInvestigacionesPorSolicitudId?SolicitudId=${props.idSolicitud}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );

      setList(response.data || []);
      setCurrentPage(1); // resetear paginación
    } catch (error) {
      console.log(error);
    }
  };

  // 🔥 ACTUALIZACIÓN INTELIGENTE
  const onRegistroCreado = (data) => {
    if (Array.isArray(data)) {
      setList((prev) => [...data, ...prev]);
      setCurrentPage(1);
    } else {
      obtenerLista(); // fallback si backend no devuelve registros
    }
  };

  // 🔹 PAGINACIÓN
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(list.length / itemsPerPage);

  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="font-weight-bold text-primary">
            8.4 Estudios de investigación en salud (últimos 4 años)
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            window.location.href.includes("ProcesoAutoevaluacion") && (
              <>
                <CreaInvestigaciones
                  idSolicitud={props.idSolicitud}
                  onRegistroCreado={onRegistroCreado}
                />
                <br />
                <a
                  href="../../../formatos/FormatoEstudiosDeInvestigacion.xlsx"
                  download
                >
                  Descargar Formato
                </a>
              </>
            )}

          <hr />

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Tema</th>
                  <th>Convenio</th>
                  <th>Fecha Inicio</th>
                  <th>Fecha Fin</th>
                  <th>Resultados Principales</th>
                  <th>Aplicación Institucional</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.tema}</td>
                      <td>{item.convenio}</td>
                      <td>{item.fecha_Inicio}</td>
                      <td>{item.fecha_Fin}</td>
                      <td>{item.resultados_Principales}</td>
                      <td>{item.resultados_Institucionales}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* 🔹 PAGINACIÓN */}
          {list.length > 0 && (
            <div className="text-center mt-3">
              <button
                className="btn btn-primary mr-2"
                onClick={() => setCurrentPage((p) => p - 1)}
                disabled={currentPage === 1}
              >
                Anterior
              </button>

              <span>
                Página {currentPage} de {totalPages}
              </span>

              <button
                className="btn btn-primary ml-2"
                onClick={() => setCurrentPage((p) => p + 1)}
                disabled={currentPage === totalPages}
              >
                Siguiente
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Titulo10SeccionA;
